export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, {
      ...eventParams,
      timestamp: new Date()?.toISOString()
    });
  }
};

export const trackCampaignGoal = (goalType, goalData = {}) => {
  trackEvent('campaign_goal_completion', {
    goal_type: goalType,
    ...goalData
  });
};

export const trackUserBehaviorFunnel = (funnelStep, stepData = {}) => {
  trackEvent('user_behavior_funnel', {
    funnel_step: funnelStep,
    ...stepData
  });
};

export const trackCampaignAttribution = (attributionData = {}) => {
  trackEvent('campaign_attribution', {
    ...attributionData
  });
};

export const trackEmailCampaignEvent = (action, campaignData = {}) => {
  trackEvent('email_campaign', {
    action,
    ...campaignData
  });
};

export const trackAutomationRuleEvent = (action, ruleData = {}) => {
  trackEvent('automation_rule', {
    action,
    ...ruleData
  });
};

export const trackRevenueConversion = (conversionData = {}) => {
  trackEvent('revenue_conversion', {
    currency: 'MXN',
    ...conversionData
  });
  
  if (conversionData?.value) {
    trackEvent('purchase', {
      currency: 'MXN',
      value: conversionData?.value,
      transaction_id: conversionData?.transactionId,
      items: conversionData?.items || []
    });
  }
};

export const trackEngagementMetric = (metricType, metricData = {}) => {
  trackEvent('engagement_metric', {
    metric_type: metricType,
    ...metricData
  });
};

export const trackPerformanceAlert = (alertType, alertData = {}) => {
  trackEvent('performance_alert', {
    alert_type: alertType,
    ...alertData
  });
};

export default {
  trackEvent,
  trackCampaignGoal,
  trackUserBehaviorFunnel,
  trackCampaignAttribution,
  trackEmailCampaignEvent,
  trackAutomationRuleEvent,
  trackRevenueConversion,
  trackEngagementMetric,
  trackPerformanceAlert
};